// https://usehooks-ts.com/react-hook/use-is-mounted
import { useCallback, useEffect, useRef } from 'react';
// This is used to make sure the component is still
// mounted when trying to make a state update or after an async request which
// response may update the state

export function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, [isMounted]);
}
